/* Passengers, luggage and the customer's note - from the trip form to the lead.

   The trip form (pages/LocationPicker) collects them; a lead is filed later, from the
   car list or a car's page, when the customer taps Call. They travel in session storage
   beside the rest of the trip (the sramika_ss_home_* keys), so the lead carries what the
   customer actually asked for and the partner sees it.

   The server checks and cleans all three again (backend/utils/tripExtras.js); the limits
   here only keep the form honest. */

/* One key per flow. The hire-driver form collects the same three things, and the two
   flows never share trip context (see utils/hireTripContext): a note written for a cab
   must not ride along on a driver's lead, or the other way round. */
const KEYS = { CAB: "sramika_ss_home_tripExtras", HIRE: "sramika_ss_hire_tripExtras" };
const keyFor = (flow) => KEYS[flow] || KEYS.CAB;

export const PASSENGERS_MAX = 35;
export const LUGGAGE_MAX = 35;
export const NOTE_MAX = 300;

const count = (v, min, max) => {
  const n = Math.round(Number(v));
  return Number.isFinite(n) && n >= min && n <= max ? n : null;
};

export function saveTripExtras({ passengers, luggage, notes }, flow = "CAB") {
  try {
    sessionStorage.setItem(keyFor(flow), JSON.stringify({
      passengers: count(passengers, 1, PASSENGERS_MAX),
      luggage: count(luggage, 0, LUGGAGE_MAX),
      notes: String(notes || "").trim().slice(0, NOTE_MAX),
    }));
  } catch { /* storage unavailable - the lead simply goes without them */ }
}

/* The fields a lead request carries: passengers, luggage, tripNotes. Nothing that was
   not set - an empty note is left out rather than sent blank. */
/* The owner's or driver's own link this visit came through (sramika.com/o/<CODE>), so a
   call it brings is counted for them (Oct 2026). Kept for the visit only. */
const VIA_KEY = "sramika_via_share";
export const setViaShare = (code) => { try { sessionStorage.setItem(VIA_KEY, String(code || "")); } catch { /* private mode */ } };
export function readViaShare() {
  try {
    const c = String(sessionStorage.getItem(VIA_KEY) || "").toUpperCase();
    return /^[A-Z]{2,6}\d{2,3}$/.test(c) ? { viaShare: c } : {};
  } catch { return {}; }
}

export function readTripExtras(flow = "CAB") {
  try {
    const raw = JSON.parse(sessionStorage.getItem(keyFor(flow)) || "null");
    if (!raw || typeof raw !== "object") return readViaShare();
    const out = { ...readViaShare() };
    const p = count(raw.passengers, 1, PASSENGERS_MAX);
    const l = count(raw.luggage, 0, LUGGAGE_MAX);
    const n = String(raw.notes || "").trim().slice(0, NOTE_MAX);
    if (p !== null) out.passengers = p;
    if (l !== null) out.luggage = l;
    if (n) out.tripNotes = n;
    return out;
  } catch {
    return {};
  }
}
